import React, { Component } from 'react';
import '../index.css';
import { Fragment } from 'react';
import { Grid } from '@material-ui/core';

import CumulativePremiums from '../V1/StatBoxes/CumulativePremiums';
import CumulativeVolumes from '../V1/StatBoxes/CumulativeVolumes';

import V1TopTradersByPremiumBought from './Tables/V1TopTradersByPremiumBought';

import V1_Daily_Volumes from './Graphs/V1_daily_volumes_by_underlying';
import V1_Weekly_Volumes from './Graphs/V1_weekly_volumes_by_underlying';
import V1_Monthly_Volumes from './Graphs/V1_monthly_volumes_by_underlying'

import V1_Daily_Premiums from './Graphs/V1_daily_premiums_by_underlying';
import V1_Weekly_Premiums from './Graphs/V1_weekly_premiums_by_underlying';
import V1_Monthly_Premiums from './Graphs/V1_monthly_premiums_by_underlying';

import V1_Monthly_Volumes_By_Type from './Graphs/V1_monthly_volumes_by_type';
import V1_Monthly_Premiums_By_Type from './Graphs/V1_monthly_premiums_by_type';

import V1_volume_and_gas_prices from './Graphs/V1_volume_and_gas_prices';
import PaginatedV1ActiveOptionsTable from './Tables/PaginatedV1ActiveOptionsTable';
import PaginatedV1ExpiredOptionsTable from './Tables/PaginatedV1ExpiredOptionsTable';
import V1AggregatedByUnderlying from './Tables/V1AggregatedByUnderlying';
import V1AggregatedByOptionType from './Tables/V1AggregatedByOptionType';
import V1AggregatedByBoughtVsSold from './Tables/V1AggregatedByBoughtVsSold';
import V1ExpiredAggregateStats from './Tables/V1ExpiredAggregateStats';


class V1 extends Component {
  
  render() {
    return (
      <Fragment>
        <div style={{ margin: '30px' }}>
          <Grid
            className='container'
            container
            spacing={3}
          >
            <Grid
              item
              lg={6}
              sm={6}
              xs={12}
            >
              <CumulativePremiums />
            </Grid>
            <Grid
              item
              lg={6}
              sm={6}
              xs={12}
            >
              <CumulativeVolumes />
            </Grid>
            <Grid
              item
              lg={6}
              xs={12}
            >
              <V1_Daily_Volumes />
            </Grid>
            
            <Grid
              item
              lg={6}
              xs={12}
            >
              <V1_Daily_Premiums />
            </Grid>
            <Grid
              item
              lg={6}
              xs={12}
            >
              <V1_Weekly_Volumes />
            </Grid>
            <Grid
              item
              lg={6}
              xs={12}
            >
              <V1_Weekly_Premiums />
            </Grid>
            <Grid
              item
              lg={6}
              xs={12}
            >
              <V1_Monthly_Volumes />
            </Grid>
            <Grid
              item
              lg={6}
              xs={12}
            >
              <V1_Monthly_Premiums />
            </Grid>
            <Grid
              item
              lg={6}
              xs={12}
            >
              <V1_Monthly_Volumes_By_Type />
            </Grid>
            <Grid
              item
              lg={6}
              xs={12}
            >
              <V1_Monthly_Premiums_By_Type />
            </Grid>
            
            <Grid
              item
              lg={12}
              xs={12}
            >
              <V1_volume_and_gas_prices/>
            </Grid>
          </Grid>
          <section id='main' style={{ marginTop: '30px' }}>
            <div className='main-text'>
              <V1AggregatedByOptionType />
            </div>
          </section>
          <section id='main' style={{ marginTop: '30px' }}>
            <div className='main-text'>
              <V1AggregatedByUnderlying />
            </div>
          </section>
          <section id='main' style={{ marginTop: '30px' }}>
            <div className='main-text'>
              <V1AggregatedByBoughtVsSold />
            </div>
          </section>
          <section id='main' style={{ marginTop: '30px' }}>
            <div className='main-text'>
              <V1TopTradersByPremiumBought />
            </div>
          </section>
          <section id='main' style={{ marginTop: '30px' }}>
            <div className='main-text'>
              <PaginatedV1ActiveOptionsTable />
            </div>
          </section>
          <section id='main' style={{ marginTop: '30px' }}>
            <div className='main-text'>
              <PaginatedV1ExpiredOptionsTable />
            </div>
          </section>
          <section id='main' style={{ marginTop: '30px' }}>
            <div className='main-text'>
              <V1ExpiredAggregateStats />
            </div>
          </section>
        </div>
      </Fragment>
    );
  }
}

export default V1;
